//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    text: {
      type: String,
      required: true
    },
    number: {
      type: Number,
      required: false,
      default: -1
    },
    checked: {
      type: Boolean,
      required: false,
      default: false
    },
    isExcluded: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
